import { Box, Card, CardContent, FormGroup, Grid, ListItem, TextField, Typography, Stack, Table, IconButton, TableContainer, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import CommonLayout from 'layouts/DashboardLayout';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { deleteReason, deleteWalletReason, editRefundReason, fetchRefundStatus, fetchWalletTable, getBlockReason, openSnackbar, updateBlockReason, updateRefundData } from '../../redux/slices/common';
import MDButton from 'components/MDButton';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import EditIcon from 'common/customIcons/edit';
import DeleteIcon from 'common/customIcons/delete';
import noDataFound from 'assets/images/nothing-found.svg';
import { closeCustomModalDialog, openCustomModalDialog, setModalLoader } from '../../redux/slices/modalSlice';
import { Riple } from 'react-loading-indicators';
import ActiveIcon from 'common/customIcons/active';
import InActiveIcon from 'common/customIcons/inactive';
import CommonQuillEditor from 'common/editor';
import { getData } from 'utilities/common';
import { getPermissionsByMode } from 'utilities/common';
import { hasSectionPermission } from 'utilities/common';

export default function ManageWalletPayment() {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        "cardRefund": "",
        "walletRefund": ""
    })
    const [messageData, setMessageData] = useState('')

    const { refundList = {}, tableloading: tableloading = false, isLoading = false, blockReason = {} } = useSelector(state => state.common);
    const { data } = blockReason
    useEffect(() => {
        setMessageData(data?.blockReason)
    }, [data])


    const showResponseMessage = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
        }
    };

    useEffect(() => {
        dispatch(fetchWalletTable())
        dispatch(getBlockReason());

        // fetchData()
    }, []);

    const fetchData = () => {
        dispatch(fetchRefundStatus()).then((res) => {
        }).catch((err) => {
            showResponseMessage(err?.message, 'error');
        });
    }

    const deleteHandler = (announcementId) => {
        dispatch(setModalLoader(true))
        dispatch(deleteWalletReason(announcementId)).unwrap().then((res) => {
            showError(res?.message, 'success')
            dispatch(closeCustomModalDialog())
            dispatch(fetchWalletTable())
        }).catch((err) => {
            dispatch(setModalLoader(false))
            showError(err?.message, 'error')
        })
    }

    const showError = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }))
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }))
        }
    }

    const handleRefundAdd = (id) => {
        dispatch(openCustomModalDialog({
            modal: 'WALLET_REASON_ADD',
            modalData: id ? id : ""
        }))
    }
    const handleSubmit = () => {
        dispatch(updateBlockReason({ blockReason: messageData })).unwrap()
            .then(res => {
                showResponseMessage(res?.message, 'success')
            })
    }


    let localUser = getData('login-user-info')
    if (localUser) {
        localUser = JSON.parse(localUser)
    }

    const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
    const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

    const canCreate = hasSectionPermission(permissionsForMode, "Settings", "Create");
    const canEdit = hasSectionPermission(permissionsForMode, "Settings", "Edit/Update");
    const canView = hasSectionPermission(permissionsForMode, "Settings", "View Only");
    const canDelete = hasSectionPermission(permissionsForMode, "Settings", "Delete");

    return (
        <CommonLayout>
            <Box p={{ xs: 2, sm: 3, lg: 4 }} className="manage-wallet-reason">
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={6}>


                        <Grid container alignItems="center" rowSpacing={2} columnSpacing={2} mb={2} mt={4}>
                            <Grid item xs={12} sm={6}>
                                <Typography variant='h4'>Manage Wallet Reason</Typography>
                            </Grid>
                            {
                                canCreate &&
                                <Grid item xs={12} sm={6}>
                                    <Stack direction="row" justifyContent={{ xs: 'start', sm: 'end' }} flexWrap="wrap" alignItems="stretch" gap={2}>
                                        <MDButton
                                            startIcon={<AddRoundedIcon fontSize='small' />}
                                            variant="contained" color="primary" fontSize="small"
                                            sx={{ minWidth: '175px', padding: "0.5rem 1.5rem", minHeight: "2rem", fontSize: "14px" }} onClick={() => handleRefundAdd()}  >
                                            Add Reason
                                        </MDButton>
                                    </Stack>
                                </Grid>
                            }
                        </Grid>

                        <Card style={{ boxShadow: "none" }}>
                            <CardContent sx={{ px: 4, py: 3 }}>
                                {
                                    tableloading ?
                                        <Box >
                                            <div className='loading_spin'>
                                                <Riple color='#3135cc' size='medium' text='' textColor='' />
                                            </div>
                                        </Box> :
                                        <>
                                            {
                                                // mainAnnouncementsData?.data?.length === 0 ?
                                                refundList?.reasons?.length === 0 ?
                                                    <ListItem>
                                                        {
                                                            !tableloading &&
                                                            <Box textAlign='center' className='w-100 no-data-found mt-5'>
                                                                <img style={{ maxWidth: '120px' }} src={noDataFound} alt='No Results Found' />
                                                                <p className='text-12' ><strong>No Results Found</strong></p>
                                                            </Box>
                                                        }
                                                    </ListItem>
                                                    :
                                                    <TableContainer sx={{ maxHeight: 440 }}>
                                                        <Table aria-label="simple table">
                                                            <TableHead sx={{ display: "table-header-group", backgroundColor: '#F1F1F1' }}>
                                                                <TableRow>
                                                                    <TableCell sx={{ color: 'grey.600', fontSize: '0.75rem', py: 1 }} width="60%">Reason</TableCell>
                                                                    <TableCell sx={{ color: 'grey.600', fontSize: '0.75rem', py: 1 }}>Status</TableCell>
                                                                    <TableCell sx={{ color: 'grey.600', fontSize: '0.75rem', py: 1 }} align="right">Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {
                                                                    // mainAnnouncementsData?.data?.map((announceData) => {
                                                                    refundList?.reasons?.map((announceData) => {
                                                                        return (
                                                                            <TableRow key={announceData?._id}>
                                                                                <TableCell>
                                                                                    <Typography className='text-14'>{announceData?.walletReason}</Typography>
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    <Typography className='text-14'
                                                                                    >{announceData?.reasonStatus ? <Box color='#24CA49' display='flex' alignItems='center'>
                                                                                        <ActiveIcon width='18px' height='18px' flex='none' />
                                                                                        <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>Active</Typography>
                                                                                    </Box> : <Box color='#FD4438' display='flex' alignItems='center'>
                                                                                        <InActiveIcon width='18px' height='18px' flex='none' />
                                                                                        <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>Inactive</Typography>
                                                                                    </Box>}</Typography>
                                                                                </TableCell>
                                                                                <TableCell align="right">
                                                                                    <Box display='flex' alignItems='center' justifyContent='end' className='table-action-btn'>
                                                                                        <IconButton disabled={!canEdit} color='primary' size='small' variant='primary' onClick={() => handleRefundAdd(announceData)}>
                                                                                            <EditIcon width='16px' height='16px' />
                                                                                        </IconButton>
                                                                                        <IconButton disabled={!canDelete} color='error' size='small' variant='primary' sx={{ marginLeft: 1 }}
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation()
                                                                                                dispatch(openCustomModalDialog({ modalData: { deleteHandler, deleteId: announceData?.reasonId, deleteType: 'Wallet Reason' }, modal: 'DELETE_MODAL' }))
                                                                                            }}  >
                                                                                            <DeleteIcon width='16px' height='16px' />
                                                                                        </IconButton>
                                                                                    </Box>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        )
                                                                    })
                                                                }
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                            }</>
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>

            <Box p={{ xs: 2, sm: 3, lg: 4 }}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={6}>
                        <Box mb={3}>
                            <Typography variant='h4'>Reason for Online Payment Block</Typography>
                            <Typography style={{ fontSize: "14px" }}>(Message that customers sees on website)</Typography>
                        </Box>
                        <Card sx={{ p: 4 }}>
                            <Typography variant='h5' mb={2}>Message/Reason for block</Typography>
                            <CardContent sx={{ p: 0 }}>
                                <FormGroup>
                                    <CommonQuillEditor
                                        value={messageData || ''}
                                        onChange={(value) => setMessageData(value)}
                                    />
                                </FormGroup>
                                {
                                    (canCreate || canEdit) &&
                                    <MDButton
                                        sx={{ minWidth: '160px' }}
                                        type='button'
                                        variant='contained'
                                        color='primary'
                                        onClick={handleSubmit}
                                        disabled={isLoading}
                                        loading={isLoading}
                                    >
                                        Save
                                    </MDButton>
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </CommonLayout>
    );
}